<template>
  <div class="navigation-buttons flex mt-auto">
    <c-button
      :theme="'secondary'"
      :disabled="isGoBackDisabled"
      @click.prevent="onGoBack">
      Tilbage
    </c-button>

    <c-button
      :form="formId"
      :type="formId? 'submit' : 'button'"
      @click.prevent="onGoNext">
      <template v-if="isSummaryView">
        Ordreoversigt
      </template>
      <template v-else>
        Næste
      </template>
    </c-button>
  </div>
</template>

<script>
export default {
  name: 'navigation-buttons',
  props: {
    formId: {
      default: '',
      type: String
    },
    isGoBackDisabled: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    onGoNext () {
      this.$emit('nextBtnClicked');
    },
    onGoBack () {
      this.$emit('backBtnClicked');
    },
  },
  computed: {
    isSummaryView () {
      if (this.$route.query && this.$route.query.wardrobeSummary) {
        return true;
      }

      return false;
    }
  }
}
</script>
